import { RootState } from '@store';

// Customer
export const selectCustomer = (state: RootState) => {
  return state.customer?.customer;
};

// BOS Customer
export const selectBosCustomer = (state: RootState) => {
  return state.customer?.customer?.bosCustomer;
};
